module.exports = __webpack_public_path__ + "static/media/mobi-logo-login.05b35052.svg";